import React from "react";

export default function FilterBar({ filters, active, onChange }) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide">
      {filters?.map((f) => (
        <button
          key={f?.value}
          onClick={() => onChange(f?.value)}
          className="flex-shrink-0 text-xs md:text-sm font-medium px-3 md:px-4 py-1.5 rounded-full border transition-all duration-200 whitespace-nowrap"
          style={{
            background: active === f?.value ? "var(--color-primary)" : "var(--color-card)",
            color: active === f?.value ? "white" : "var(--color-muted-foreground)",
            borderColor: active === f?.value ? "var(--color-primary)" : "var(--color-border)",
          }}
        >
          {f?.label}
        </button>
      ))}
    </div>
  );
}